import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormLabel as MuiFormLabel, } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { styled } from '../../utils';
import { Chip } from '../Chip';
import { Typography } from '../Typography';
export function ChipGroup(props) {
    const { onChange: onChangeRaw, options: optionsRaw, value, disabled = undefined, error, helperText, label, required, className, inline, size, flat, } = props;
    const options = useMemo(() => optionsRaw || [], [optionsRaw]);
    const onChange = useCallback((idx) => {
        !!onChangeRaw && onChangeRaw(options[idx].value);
    }, [onChangeRaw, options]);
    return (_jsxs(ContainerStyled, { className: className, children: [_jsxs(FieldStyled, { inline: inline, children: [!!label && (_jsx(LabelStyled, { component: "legend", error: error, children: label && (_jsxs(_Fragment, { children: [label, required && '\xa0*'] })) })), _jsx(ChipListStyled, { children: options.map((option, idx) => (_jsx(ChipContainerStyled, { children: _jsx(Chip, { disabled: disabled === undefined ? option?.disabled : disabled, active: value === option.value, onClick: () => {
                                    if (value !== option.value)
                                        onChange(idx);
                                }, label: option.label, size: size ?? 'medium', flat: flat ?? false }) }, idx))) })] }), error && helperText && (_jsx(Typography, { color: "error", variant: "body1", children: helperText }))] }));
}
const ContainerStyled = styled('div')(({ theme }) => ({
    display: 'grid',
    rowGap: theme.spacing(2),
}));
const FieldStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'inline',
})(({ theme, inline }) => ({
    display: 'flex',
    flexDirection: inline ? 'row' : 'column',
    alignItems: inline ? 'center' : 'normal',
    justifyContent: inline ? 'space-between' : 'normal',
    flexWrap: 'wrap',
    rowGap: theme.spacing(2),
}));
const LabelStyled = styled(MuiFormLabel)(({ theme, error }) => ({
    color: error ? theme.palette.error.main : 'inherit',
}));
const ChipListStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    flexWrap: 'wrap',
    rowGap: theme.spacing(2),
}));
const ChipContainerStyled = styled('div')(({ theme }) => ({
    '&:not(:last-of-type)': {
        paddingRight: theme.spacing(2),
    },
}));
